import React, { Component } from "react";
import { ConnectedRouter } from "connected-react-router";
import AppContext from "@my-dld/contexts/AppContext";
import { Route } from "react-router";
import AppMessage from "@my-dld/components/AppMessage";
import { history } from "@my-dld/reducers/store";
import FeesReceipt from "@my-dld/screens/FinanceDepService/FeesReceipt";

export class FeesReceiptService extends Component {
	render() {
		return <ConnectedRouter history={ history }>
			<AppContext>
				<Route path="/" component={ FeesReceipt }/>
				<AppMessage/>
			</AppContext>
		</ConnectedRouter>;
	}
}

export default FeesReceiptService;
